import './toggleButton.scss';

export interface ToggleButtonProps {
    handleClick: () => void;
    label: string | JSX.Element;
    isOn: boolean
    dataTestId?: string;
}

const ToggleButton = ({ handleClick, label, isOn, dataTestId }: ToggleButtonProps) => {
    console.log(`[ToggleButton ${dataTestId}] isOn=${isOn}, className will be: "toggle-button ${isOn ? 'on' : ''}"`);
    return (
        <label data-testid="toggle-wrapper" id="toggle-wrapper">
            <a
                id="toggle-button"
                className={`toggle-button ` + (isOn ? 'on' : '')}
                role="button"
                tabIndex={0}
                onClick={handleClick}
                data-testid={"toggle-button-" + dataTestId}
            ></a>
            <span className="toggle-label"> {label} </span>
        </label>
    );
};

export default ToggleButton;